<template>
  <div class="col-lg-4 col-md-6 mb-3">
    <RouterLink :to="'esquema/'+entidad.id">
    <div class="card">
      <div class="card-header mx-4 p-3 text-center" style="display: grid;justify-content: center;">
        <div class="icon icon-shape icon-lg shadow text-center border-radius-lg" style="display: grid;justify-content: center;align-items: center;" :style="{ backgroundColor: entidad.color }">
          <i :class="entidad.icono" style="font-size: xx-large;color: white"></i>
        </div>
      </div>
      <div class="card-body pt-0 p-3 text-center">
        <h6 class="text-center mb-0">{{entidad.grupo}}</h6>
        <hr class="horizontal dark my-3">
        <h5 class="mb-0">{{entidad.nombre}}</h5>
      </div>
    </div>
    </RouterLink>
  </div>
</template>

<script>
export default {
  name: "DashboardCard",
  props: {
    entidad:Object,
  }
}
</script>

<style scoped>

</style>